module.exports = __webpack_public_path__ + "img/logged-out.02799988.webp";